import { render, staticRenderFns } from "./HistoryButtons.vue?vue&type=template&id=478dffd4&lang=pug&"
import script from "./HistoryButtons.vue?vue&type=script&lang=js&"
export * from "./HistoryButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports